<template>
	<div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-db-background bg-cover">
		<div class="xl:absolute xl:right-0 md:w-3/5 m-auto xl:w-2/5">
			<div class="bg-white py-8 px-4 shadow sm:rounded-sm sm:px-10 md:mx-auto lg:w-3/4 w-full">
				<div class="sm:mx-auto sm:w-full sm:max-w-sm">
					<img
						:class="brand.logos.loginCard.class"
						:src="brand.logos.loginCard.src"
						:alt="brand.logos.loginCard.alt">
				</div>

				<slot />

				<div
					v-if="brand.logos.loginFooter"
					class="mt-12 flex justify-center items-center gap-8">
					<a
						:href="brand.siteUrl"
						target="_blank"
						class="w-1/2">
						<img
							:src="brand.logos.loginFooter.src"
							:alt="brand.logos.loginFooter.alt">
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	export default { name: 'BrandCardLayout' } // name the component
</script>

<script setup lang="ts">
	// brand
	import {
		useBrand
	} from "@/utilities/brand"

	const brand = useBrand()
</script>
